module.exports = __webpack_public_path__ + "build/img/skype.9c9cfcb4.png";